import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import componentStyles from './ghs-event-detail.css.lit';
import { LightController } from '../../controllers/light-controller';

import '../ghs-icon/ghs-icon';
import '../ghs-heading/ghs-heading';

/**
 * The Event Detail component
 *
 * @element ghs-event-detail
 * @slot heading - Contains heading content.
 * @slot date-time - Contains date and time content
 * @slot openings - Contains number of openings content
 * @slot cta - Contains ghs-button (secondary variant) CTA content
 * @slot defaultSlot - Contains the content.
 */
@customElement('ghs-event-detail')
export class GhsEventDetail extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightController = new LightController(
    this,
    GhsEventDetail.styles,
    this.tagName.toLowerCase()
  );

  /**
   * Automatically set param, counts the rendered number of sections.
   */
  @property({ type: Number, reflect: true })
  sections: number;

  @state() hasDateSlot = false;
  @state() hasTimeSlot = false;
  @state() hasLocationSlot = false;
  @state() hasPaymentSlot = false;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasDateSlot = this.querySelector('[slot="date"]') !== null;
    this.hasTimeSlot = this.querySelector('[slot="time"]') !== null;
    this.hasLocationSlot = this.querySelector('[slot="location"]') !== null;
    this.hasPaymentSlot = this.querySelector('[slot="payment"]') !== null;
    this.sections = this.countContent([
      this.hasTimeSlot,
      this.hasLocationSlot,
      this.hasPaymentSlot,
    ]);
  }

  countContent(testArr: boolean[]): number {
    let count = 0;

    testArr.forEach(element => {
      if (element) {
        count++;
      }
    });

    return count;
  }

  render(): TemplateResult {
    return html`
      <div class="event-detail">
        ${this.hasDateSlot ? html`<slot name="date"></slot>` : nothing}
        <div class="content">
          ${this.hasTimeSlot ? html`<slot name="time"></slot>` : nothing}
          ${this.hasLocationSlot
            ? html`<slot name="location"></slot>`
            : nothing}
          ${this.hasPaymentSlot
            ? html`<div class="payment">
                <slot name="payment"></slot>
              </div>`
            : nothing}
        </div>
      </div>
    `;
  }
}
